var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 15,
    viewBox: "0 0 26 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_6",
    "data-name": "Polygon 6",
    d: "M13,0,26,15H0Z",
    transform: "translate(26 15) rotate(180)",
    fill: "#f4ea5b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowDownArrow);
export default __webpack_public_path__ + "static/media/yellow_down_arrow.557b28fc9e934d2fbbfced4c4cce0ff0.svg";
export { ForwardRef as ReactComponent };